"use client";

import { c as _c } from "react/compiler-runtime";
import UserPageProfileWaveMasonry, { type ProfileIdentitySummary } from "@/components/user/waves/UserPageProfileWaveMasonry";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ApiWaveCuration } from "@/generated/models/ApiWaveCuration";
import { useWaveCurationDrops } from "@/hooks/useWaveCurationDrops";
import { PlusIcon } from "@heroicons/react/24/outline";
import { resolveProfileCurationViewState } from "./userPageProfileWave.helpers";
import { CurationEmptyPanel, InfoPanel, LoadingPanel, RetryButton } from "./UserPageProfileWaveShared";
export default function UserPageProfileWaveContent(t0) {
  const $ = _c(47);
  const {
    canManageOwnOfficialWave,
    containerWidth,
    onCreateCuration,
    profileIdentity,
    areCurationsError,
    areCurationsFetching,
    areCurationsLoading,
    hasLoadedCurations,
    onRetryCurations,
    profileCuration,
    wave
  } = t0;
  const t1 = profileCuration?.id;
  const t2 = profileCuration !== null;
  let t3;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== wave) {
    t3 = {
      wave,
      curationId: t1,
      enabled: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = wave;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    dataUpdatedAt,
    drops,
    fetchNextPage,
    hasNextPage,
    isError: areDropsError,
    isFetching: areDropsFetching,
    isFetchingNextPage,
    isPlaceholderData,
    refetch: refetchDrops
  } = useWaveCurationDrops(t3);
  let t4;
  if ($[4] !== areCurationsError || $[5] !== areCurationsLoading || $[6] !== areDropsError || $[7] !== canManageOwnOfficialWave || $[8] !== containerWidth || $[9] !== dataUpdatedAt || $[10] !== drops || $[11] !== fetchNextPage || $[12] !== hasLoadedCurations || $[13] !== hasNextPage || $[14] !== isFetchingNextPage || $[15] !== isPlaceholderData || $[16] !== profileCuration) {
    t4 = resolveProfileCurationViewState({
      areCurationsError,
      areCurationsLoading,
      canManageOwnOfficialWave,
      containerWidth,
      hasLoadedCurations,
      profileCuration,
      drops,
      dropsDataUpdatedAt: dataUpdatedAt,
      areDropsError,
      isDropsPlaceholderData: isPlaceholderData,
      fetchNextPage,
      hasNextPage,
      isFetchingNextPage
    });
    $[4] = areCurationsError;
    $[5] = areCurationsLoading;
    $[6] = areDropsError;
    $[7] = canManageOwnOfficialWave;
    $[8] = containerWidth;
    $[9] = dataUpdatedAt;
    $[10] = drops;
    $[11] = fetchNextPage;
    $[12] = hasLoadedCurations;
    $[13] = hasNextPage;
    $[14] = isFetchingNextPage;
    $[15] = isPlaceholderData;
    $[16] = profileCuration;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const state = t4;
  let t5;
  if ($[18] !== refetchDrops) {
    t5 = async () => {
      await refetchDrops();
    };
    $[18] = refetchDrops;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const retryDropsLoad = t5;
  let t6;
  if ($[20] !== canManageOwnOfficialWave || $[21] !== onCreateCuration) {
    t6 = canManageOwnOfficialWave ? <ProfileCurationActionButton label="Create curation" onClick={onCreateCuration} /> : undefined;
    $[20] = canManageOwnOfficialWave;
    $[21] = onCreateCuration;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  const createCurationAction = t6;
  switch (state.kind) {
    case "curations_error":
      {
        let t7;
        if ($[23] !== areCurationsFetching || $[24] !== onRetryCurations) {
          t7 = <InfoPanel title="Unable to load curations" message="There was a temporary problem loading the curations in this wave." actions={<RetryButton isLoading={areCurationsFetching} onClick={onRetryCurations} />} />;
          $[23] = areCurationsFetching;
          $[24] = onRetryCurations;
          $[25] = t7;
        } else {
          t7 = $[25];
        }
        return t7;
      }
    case "loading_curations":
      {
        let t7;
        if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = <LoadingPanel label="Loading curations..." />;
          $[26] = t7;
        } else {
          t7 = $[26];
        }
        return t7;
      }
    case "no_curation":
      {
        let t7;
        if ($[27] !== createCurationAction || $[28] !== state.emptyState.message || $[29] !== state.emptyState.title) {
          t7 = <CurationEmptyPanel title={state.emptyState.title} message={state.emptyState.message} primaryAction={createCurationAction} />;
          $[27] = createCurationAction;
          $[28] = state.emptyState.message;
          $[29] = state.emptyState.title;
          $[30] = t7;
        } else {
          t7 = $[30];
        }
        return t7;
      }
    case "empty_drops":
      {
        let t7;
        if ($[31] !== state.emptyState.message || $[32] !== state.emptyState.title) {
          t7 = <CurationEmptyPanel title={state.emptyState.title} message={state.emptyState.message} />;
          $[31] = state.emptyState.message;
          $[32] = state.emptyState.title;
          $[33] = t7;
        } else {
          t7 = $[33];
        }
        return t7;
      }
    case "drops_error":
      {
        let t7;
        if ($[34] !== areDropsFetching || $[35] !== retryDropsLoad) {
          t7 = <InfoPanel title="Unable to load curation" message="There was a temporary problem loading drops for this curation." actions={<RetryButton isLoading={areDropsFetching} onClick={retryDropsLoad} />} />;
          $[34] = areDropsFetching;
          $[35] = retryDropsLoad;
          $[36] = t7;
        } else {
          t7 = $[36];
        }
        return t7;
      }
    case "loading_drops":
      {
        let t7;
        if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = <LoadingPanel label="Loading curation..." />;
          $[37] = t7;
        } else {
          t7 = $[37];
        }
        return t7;
      }
    case "ready":
      {
        let t7;
        if ($[38] !== containerWidth || $[39] !== profileIdentity || $[40] !== state.curation.id || $[41] !== state.curation.name || $[42] !== state.drops || $[43] !== state.fetchNextPage || $[44] !== state.hasNextPage || $[45] !== state.isFetchingNextPage) {
          t7 = <div className="tw-overflow-hidden tw-rounded-2xl"><UserPageProfileWaveMasonry curationId={state.curation.id} curationName={state.curation.name} containerWidth={containerWidth} drops={state.drops} fetchNextPage={state.fetchNextPage} hasNextPage={state.hasNextPage} isFetchingNextPage={state.isFetchingNextPage} showIdentity={false} profileIdentity={profileIdentity} /></div>;
          $[38] = containerWidth;
          $[39] = profileIdentity;
          $[40] = state.curation.id;
          $[41] = state.curation.name;
          $[42] = state.drops;
          $[43] = state.fetchNextPage;
          $[44] = state.hasNextPage;
          $[45] = state.isFetchingNextPage;
          $[46] = t7;
        } else {
          t7 = $[46];
        }
        return t7;
      }
  }
}
function ProfileCurationActionButton(t0) {
  const $ = _c(6);
  const {
    label,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PlusIcon className="-tw-ml-0.5 tw-h-5 tw-w-5 tw-flex-shrink-0" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <span>{label}</span>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClick || $[4] !== t2) {
    t3 = <button type="button" onClick={onClick} className="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-white tw-bg-white tw-px-3.5 tw-py-2 tw-text-sm tw-font-semibold tw-text-iron-950 tw-transition tw-duration-300 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-white disabled:tw-cursor-not-allowed disabled:tw-border-white/15 disabled:tw-bg-white/10 disabled:tw-text-iron-400 desktop-hover:hover:tw-border-iron-200 desktop-hover:hover:tw-bg-iron-100">{t1}{t2}</button>;
    $[3] = onClick;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}